import type { InternalAxiosRequestConfig } from 'axios'

import { getAccessToken, hasExpiredEntraAccessToken, hasValidEntraAccessToken } from '@/data/api/token'
import { useAuthStore } from '@/store/authStore'

/** Attach Entra Bearer when valid; expired session → anonymous guest. */
export const authInterceptor = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  if (hasExpiredEntraAccessToken()) {
    void useAuthStore.getState().logout()
    return config
  }

  if (hasValidEntraAccessToken()) {
    const token = getAccessToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
  }

  return config
}
